<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <div class="in-two-columns">
    <!-- breweryType -->

    <mat-form-field>
      <app-easy-select
        formControlName="breweryType"
        [label]="TITLE + 'BREWERY_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.BREWERY_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="breweryType | toSelectOption: 'PRODUCTS.BREWERY_TYPE.'"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- beerType -->

    <mat-form-field>
      <app-easy-select
        formControlName="beerType"
        [label]="TITLE + 'BEER_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.BEER_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="beerType | toSelectOption: 'PRODUCTS.BEER_TYPE.'"
        (ngModelChange)="onTypeSelected($event)"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- beerType ➡ spontaneouslyFermentedType -->

    <mat-form-field *ngIf="getCtrl('spontaneouslyFermentedType')">
      <app-easy-select
        formControlName="spontaneouslyFermentedType"
        [label]="TITLE + 'SPONTANEOUSLY_FERMENTED_TYPE' | translate"
        [translatePrefixForSelected]="
          'PRODUCTS.BEER_TYPE.SPONTANEOUSLY_FERMENTED_TYPE.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          spontaneouslyFermentedType
            | toSelectOption: 'PRODUCTS.BEER_TYPE.SPONTANEOUSLY_FERMENTED_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- beerType ➡ topFermentedType -->

    <mat-form-field *ngIf="getCtrl('topFermentedType')">
      <app-easy-select
        formControlName="topFermentedType"
        [label]="TITLE + 'TOP_FERMENTED_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.BEER_TYPE.TOP_FERMENTED_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          topFermentedType
            | toSelectOption: 'PRODUCTS.BEER_TYPE.TOP_FERMENTED_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- beerType ➡ bottomFermentedType -->

    <mat-form-field *ngIf="getCtrl('bottomFermentedType')">
      <app-easy-select
        formControlName="bottomFermentedType"
        [label]="TITLE + 'BOTTOM_FERMENTED_TYPE' | translate"
        [translatePrefixForSelected]="
          'PRODUCTS.BEER_TYPE.BOTTOM_FERMENTED_TYPE.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          bottomFermentedType
            | toSelectOption: 'PRODUCTS.BEER_TYPE.BOTTOM_FERMENTED_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- beerType ➡ hybridFermentedType -->

    <mat-form-field *ngIf="getCtrl('hybridFermentedType')">
      <app-easy-select
        formControlName="hybridFermentedType"
        [label]="TITLE + 'HYBRID_FERMENTED_TYPE' | translate"
        [translatePrefixForSelected]="
          'PRODUCTS.BEER_TYPE.HYBRID_FERMENTED_TYPE.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          hybridFermentedType
            | toSelectOption: 'PRODUCTS.BEER_TYPE.HYBRID_FERMENTED_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- characterOfBeer -->

    <mat-form-field>
      <app-easy-select
        formControlName="characterOfBeer"
        [label]="TITLE + 'CHARACTER_OF_BEER' | translate"
        [translatePrefixForSelected]="'PRODUCTS.CHARACTER_OF_BEER.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          characterOfBeer | toSelectOption: 'PRODUCTS.CHARACTER_OF_BEER.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- degreeOfBalling -->

    <mat-form-field *ngIf="getCtrl('degreeOfBalling')">
      <app-easy-input
        formControlName="degreeOfBalling"
        [label]="TITLE + 'DEGREE_OF_BALLING' | translate"
        type="number"
        step="1"
        min="0"
        max="100"
      >
      </app-easy-input>
    </mat-form-field>
  </div>

  <!-- sugar fields -->

  <div class="in-one-column" formGroupName="sugarContentProperties">
    <mat-form-field>
      <app-easy-checkbox
        formControlName="containsAddedSugar"
        [label]="CONTAINS_ADDED_SUGAR | translate"
        (ngModelChange)="onSweetenerOrSugarChangedAlcoholic()"
      ></app-easy-checkbox>
    </mat-form-field>

    <mat-form-field>
      <app-easy-checkbox
        formControlName="containsAddedSweetener"
        [label]="CONTAINS_ADDED_SWEETENER | translate"
        (ngModelChange)="onSweetenerOrSugarChangedAlcoholic()"
      ></app-easy-checkbox>
    </mat-form-field>
  </div>

  <div class="in-two-columns" formGroupName="sugarContentProperties">
    <mat-form-field>
      <app-easy-select
        formControlName="sugarContentType"
        [label]="SUGAR_CONTENT_TYPE | translate"
        [translatePrefixForSelected]="'PRODUCTS.SUGAR_CONTENT_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [options]="alcoholicSugarContentType"
      >
      </app-easy-select>
    </mat-form-field>

    <mat-form-field
      *ngIf="
        getCtrl(
          'sugarContentProperties.sugarContentInGramsPerHundredMilliliters'
        )
      "
    >
      <app-easy-input
        formControlName="sugarContentInGramsPerHundredMilliliters"
        class="container"
        [label]="SUGAR_CONTENT_IN_GRAMS_PER_HUNDRED_MILLILITERS | translate"
        [labelInfo]="'PRODUCTS.SUGAR_CONTENT_FIELDS.INFO' | translate"
        type="number"
        step="1"
        min="0"
        max="100"
      >
      </app-easy-input>
    </mat-form-field>
  </div>
</fieldset>
